import React from 'react';

export default function LanguageToggle({ value, onToggle, className = '' }) {
  const isGerman = value === 'de';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isGerman}
      aria-label="Toggle language"
      onClick={onToggle}
      className={`relative flex h-12 w-44 items-center justify-between rounded-full border border-white/15 bg-white/10 px-2 font-semibold text-white shadow-[0_20px_45px_-30px_rgba(236,72,153,0.5)] transition focus:outline-none focus:ring-2 focus:ring-fuchsia-300/40 ${className}`}
    >
      <span
        className={`pointer-events-none absolute inset-y-1 left-1 h-10 w-[calc(50%-0.5rem)] rounded-full bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] shadow-[0_12px_25px_-15px_rgba(236,72,153,0.7)] transition-transform duration-300 ease-out ${isGerman ? 'translate-x-0' : 'translate-x-[calc(100%+0.5rem)]'
          }`}
      />
      <span
        className={`relative z-10 flex-1 text-center text-sm ${isGerman ? 'text-white' : 'text-white/60'
          } ml-[0px]`}
      >
        DE
      </span>
      <span
        className={`relative z-10 flex-1 text-center text-sm ${isGerman ? 'text-white/60' : 'text-white'
          } ml-[20px]`}
      >
        EN
      </span>

    </button>
  );
}
